module.exports = __webpack_public_path__ + "img/hos_t.7c21f6ba.png";